/** @format */

import { useEffect, useState } from 'react';
import styles from './OrderDetails.module.css';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Breadcrumbs, Button, Dialog, DialogTitle, Link, Slide, TextField, useMediaQuery } from '@material-ui/core';
import OrderList from './OrderList/OrderList';
import { useOrderAPI } from '../hooks/useOrderAPI';
import { usePaymentAPI } from './hooks/usePaymentAPI';
import { useInvoiceAPI } from './hooks/useInvoiceAPI';
import { useNavigate, useParams } from 'react-router-dom';
import CheckIcon from 'components/common/CheckIcon/CheckIcon';
import LoadIndicator from 'components/common/LoadIndicator/LoadIndicator';
import DetailsCard from 'components/PhotoAdminComponents/Orders/DetailsCard/DetailsCard';
import { useDeliveryAPI } from './hooks/useDeliveryAPI';
import OrderHistoryWidget from 'components/PhotoAdminComponents/Orders/OrderHistoryWidget/OrderHistoryWidget';
import HistoryIcon from '@mui/icons-material/History';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { useRef } from 'react';
import { getApi } from 'api/axios';
import HistoryViewer from 'components/PhotoAdminComponents/Orders/HistoryViewer/HistoryViewer';
import sizes from 'constants/sizes';
import ConfirmDialog from 'components/common/ConfirmDialog/ConfirmDialog';
import { useSelector } from 'react-redux';
import { IconButton } from '@material-ui/core';
import DownloadIcon from '@mui/icons-material/Download';
import { Tooltip } from '@mui/material';
import StatusModifier from 'components/PhotoAdminComponents/Orders/StatusModifier/StatusModifier';
import { useTranslation } from 'react-i18next';
const OrderDetails = (props) => {
  const { id } = useParams();
  const [downloadProgress, setDownloadProgress] = useState();
  const { t } = useTranslation();

  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);

  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);

  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);

  const navigate = useNavigate();
  const [orderHistoryVisible, setOrderHistoryVisible] = useState(false);
  const toggleOrderHistoryVisible = () => setOrderHistoryVisible(!orderHistoryVisible);
  const [paymentHistoryVisible, setPaymentHistoryVisible] = useState(false);
  const togglePaymentHistoryVisible = () => setPaymentHistoryVisible(!paymentHistoryVisible);
  const [reprintDialogOpen, setReprintDialogOpen] = useState(false);
  const toogleReprintDialogOpen = () => setReprintDialogOpen(!reprintDialogOpen);

  const desktop = useMediaQuery(`(min-width:${sizes.SM.toString()}px)`);

  const { fetchOrder, order, loading, putOrder } = useOrderAPI();

  const { fetchPayment, payment } = usePaymentAPI();
  const { fetchDelivery, delivery, handleReprint, handleResend } = useDeliveryAPI();
  const { fetchInvoice, invoice, setInvoice, invoiceLoading, invoiceVendors } = useInvoiceAPI();

  const getDateString = (date) => {
    return new Date(date).toLocaleDateString('hu-HU', {
      hour: '2-digit',
      minute: '2-digit',
      seconds: '2-digit'
    });
  };

  useEffect(() => {
    fetchOrder({ id: id });
  }, [fetchOrder, id]);

  const [emailDeliveryFound, setEmailDeliveryFound] = useState(null);
  const [postDeliveryFound, setPostDeliveryFound] = useState(null);
  const [lelkesSelfDeliveryFound, setLelkesSelfDeliveryFound] = useState(null);
  const [postAndLelkesDeliveryFound, setPostAndLelkesDeliveryFound] = useState(null);
  const [deliveryStates, setDeliveryStates] = useState({});

  const [newEmail, setNewEmail] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const getStatuses = () => {
    let lastPOSTStatus = null;
    let lastPOSTDelivery = null;
    let last_LELKES_SELF_Status = null;
    let last_LELKES_SELF_Delivery = null;
    let last_EMAIL_Status = null;
    let last_EMAIL_Delivery = null;
    let last_POST_AND_LELKES_PRINT_Status = null;
    let last_POST_AND_LELKES_PRINT_Delivery = null;
    let states = deliveryStates;

    order?.deliveryReferences?.forEach((deliveryReference) => {
      if (deliveryReference?.type === 'POST') {
        lastPOSTStatus = `#${deliveryReference?.id}:${deliveryReference?.status} - ${getDateString(
          deliveryReference?.createdAt
        )}`;
        lastPOSTDelivery = deliveryReference;
      }
      if (deliveryReference?.type === 'LELKES_SELF_PRINT') {
        last_LELKES_SELF_Status = `#${deliveryReference?.id}:${deliveryReference?.status} - ${getDateString(
          deliveryReference?.createdAt
        )}`;
        last_LELKES_SELF_Delivery = deliveryReference;
      }
      if (deliveryReference?.type === 'EMAIL') {
        last_EMAIL_Status = `#${deliveryReference?.id}:${deliveryReference?.status} - ${getDateString(
          deliveryReference?.createdAt
        )}`;
        last_EMAIL_Delivery = deliveryReference;
      }
      if (deliveryReference?.type === 'POST_AND_LELKES_PRINT') {
        last_POST_AND_LELKES_PRINT_Status = `#${deliveryReference?.id}:${deliveryReference?.status} - ${getDateString(
          deliveryReference?.createdAt
        )}`;
        last_POST_AND_LELKES_PRINT_Delivery = deliveryReference;
      }
    });

    if (lastPOSTStatus) {
      states = {
        ...states,
        post: {
          title: t('orderDetails.post'),
          info: lastPOSTStatus
        }
      };
      setPostDeliveryFound(lastPOSTDelivery);
    }
    if (last_LELKES_SELF_Status) {
      states = {
        ...states,
        lelkes_self: {
          title: t('orderDetails.ownProduct'),
          info: last_LELKES_SELF_Status
        }
      };
      setLelkesSelfDeliveryFound(last_LELKES_SELF_Delivery);
    }
    if (last_EMAIL_Status) {
      states = {
        ...states,
        email: {
          title: t('orderDetails.digital'),
          info: last_EMAIL_Status
        }
      };
      setEmailDeliveryFound(last_EMAIL_Delivery);
    }
    if (last_POST_AND_LELKES_PRINT_Status) {
      states = {
        ...states,
        post_and_lelkes: {
          title: t('orderDetails.postAndLelkes'),
          info: last_POST_AND_LELKES_PRINT_Status
        }
      };
      setPostAndLelkesDeliveryFound(last_POST_AND_LELKES_PRINT_Delivery);
    }
    setDeliveryStates(states);
  };

  useEffect(() => {
    getStatuses();
  }, [order]);

  const resendDigital = () => {
    let newOrder = order;
    newOrder.customerContact = {
      ...newOrder.customerContact,
      email: newEmail
    };
    handleResend({
      id: emailDeliveryFound?.deliveryId,
      body: order
    });
    setNewEmail('');
  };

  const handleStates = (status) => {
    if (!status) return null;

    // PaymentDTO statuses (RECEIVED, INITIATED, CONFIRMED, PAID, REJECTED, CANCELLED, REFUND, TIMEOUT)
    const paymentStatusKey = `queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.${status}`;
    const paymentStatusTranslation = t(paymentStatusKey);

    // i18next returns the key itself when missing (default behavior in most setups)
    if (paymentStatusTranslation && paymentStatusTranslation !== paymentStatusKey) {
      return paymentStatusTranslation;
    }

    // Fallbacks for older / order-related statuses
    if (status === 'PENDING') return t('orderDetails.pending');
    if (status === 'PAID') return t('orderDetails.paid');
    if (status === 'CONFIRMED') return t('orderDetails.waiting');
    if (status === 'RECEIVED') return t('orderDetails.waiting');
    if (status === 'INVOICED') return t('orderDetails.invoiced');
    if (status === 'SHIPPING') return t('orderDetails.shipping');
    if (status === 'DONE') return t('orderDetails.done');
    if (status === 'REJECTED') return t('orderDetails.rejected');
    if (status === 'CANCELLED') return t('orderDetails.cancelled');
    if (status === 'TIMEOUT') return t('orderDetails.timeout');
    if (status === 'PRINTED') return t('orderDetails.printed');

    return status;
  };

  const getLatestPaymentStatus = (paymentData) => {
    if (!paymentData) return null;
    if (paymentData.status) return paymentData.status;
    if (paymentData.paymentStatusType) return paymentData.paymentStatusType;
    if (paymentData.paymentStatus) return paymentData.paymentStatus;
    return paymentData.statusUpdates?.[paymentData.statusUpdates.length - 1]?.type || null;
  };

  const getPaymentVendorTypeLabel = (vendorType) => {
    if (!vendorType) return '-';
    const key = `queryBuilder.queryParam.queryOptions.payment.paymentVendorTypeValues.${vendorType}`;
    const translation = t(key);
    // If key is missing, i18next typically returns the key itself.
    return translation && translation !== key ? translation : vendorType;
  };

  const handleGetPdf = async (id) => {
    setDownloadProgress(true);
    try {
      const res = await (
        await getApi({
          baseUrl: window._env_.REACT_APP_QDAK_PAYMENT_URL
        })
      ).get(`/admin/shops/${shopId}/invoices/${id}/document`, {
        headers: {
          'Content-Type': 'application/pdf'
        },
        responseType: 'blob'
      });
      setDownloadProgress(false);
      const href = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));

      const a = linkRef.current;
      a.download = t('orderDetails.pdfInvoice', { id: order?.id });
      a.href = href;
      a.click();
      a.href = '';
    } catch (e) {
      setDownloadProgress(false);
      console.log(e);
    }
  };
  const orderDetailsData = {
    cardTitle: t('orderDetails.cardTitle'),
    icon: <HistoryIcon />,
    tooltipText: t('orderDetails.tooltipText'),
    buttonText: desktop && t('orderDetails.buttonText'),
    handler: toggleOrderHistoryVisible,
    rows: [
      {
        title: t('orderDetails.orderId'),
        info: order?.id
      },
      {
        title: t('orderDetails.customer'),
        info: order?.billingInfo?.customerName
      },
      {
        title: t('orderDetails.phone'),
        info: order?.customerContact?.phone
      },
      {
        title: t('orderDetails.email'),
        info: order?.customerContact?.email
      },
      {
        title: t('orderDetails.address'),
        info: `${order?.billingInfo?.address?.country}, ${order?.billingInfo?.address?.zipCode} ${order?.billingInfo?.address?.city}, ${order?.billingInfo?.address?.street}`
      },
      {
        title: t('orderDetails.date'),
        info:
          order?.createdAt !== undefined
            ? new Date(order?.createdAt).toLocaleDateString('hu-HU', {
                hour: '2-digit',
                minute: '2-digit',
                seconds: '2-digit'
              })
            : t('orderDetails.noDate')
      },
      {
        title: t('orderDetails.expirationDate'),
        info: order?.deliveryTarget?.expirationDate
          ? new Date(order?.deliveryTarget?.expirationDate).toLocaleDateString('hu-HU', {
              hour: '2-digit',
              minute: '2-digit',
              seconds: '2-digit'
            })
          : t('orderDetails.noDate')
      },
      {
        title: t('orderDetails.cartId'),
        info: order?.cartId
      }
    ]
  };

  const paymentStatus = getLatestPaymentStatus(payment);
  const paymentDetailsData = {
    cardTitle: t('orderDetails.payment'),
    icon: <HistoryIcon />,
    tooltipText: t('orderDetails.paymentTooltip'),
    buttonText: desktop && t('orderDetails.buttonText'),
    buttonDisabled: !payment,
    requiredState: 'PENDING',
    handler: togglePaymentHistoryVisible,
    rows: [
      {
        title: t('orderDetails.paymentId'),
        info: order?.paymentTrxId ? order?.paymentTrxId : '-'
      },
      {
        title: t('orderDetails.paymentMethod'),
        info: payment
          ? `${getPaymentVendorTypeLabel(order?.paymentMethod)}, ${order?.paymentMode || '-'}`
          : '-'
      },
      {
        title: t('orderDetails.paymentExternalId'),
        info: payment?.externalId ? payment?.externalId : '-'
      },
      {
        title: t('orderDetails.paymentAmount'),
        info: `${order && order?.totalPrice?.grossAmount} HUF`
      },
      {
        title: t('orderDetails.paymentDate'),
        info: payment
          ? new Date(payment.createdAt).toLocaleDateString('hu-HU', {
              hour: '2-digit',
              minute: '2-digit',
              seconds: '2-digit'
            })
          : ' - '
      },
      {
        title: t('orderDetails.paymentStatus'),
        info: (
          <span
            style={{
              color: ['REJECTED', 'CANCELLED', 'TIMEOUT'].includes(paymentStatus) && 'var(--primary-error)'
            }}>
            {order?.status === 'DONE'
              ? handleStates('DONE')
              : paymentStatus
              ? handleStates(paymentStatus)
              : t('orderDetails.paymentWaiting')}
          </span>
        )
      }
    ]
  };

  const shippingDetailsData = {
    cardTitle: t('orderDetails.delivery'),
    icon: <ForwardToInboxIcon />,
    tooltipText: t('orderDetails.deliveryTooltip'),
    buttonText: desktop && t('orderDetails.resend'),
    handler: () => setIsOpen(true),
    rows: [
      {
        title: t('orderDetails.deliveryMode'),
        info: t('orderDetails.inSchool')
      },
      {
        title: t('orderDetails.deliveryTarget'),
        info: order?.deliveryTarget?.deliveryTarget
      },
      ...Object.values(deliveryStates)
    ]
  };

  const billingDetailsData = {
    cardTitle: t('orderDetails.invoice'),
    requiredState: 'INVOICED',
    rows: [
      {
        title: t('orderDetails.invoiceName'),
        info: order?.billingInfo?.companyName ? order?.billingInfo?.companyName : order?.billingInfo?.customerName
      },
      {
        title: t('orderDetails.invoiceAddress'),
        info: `${order?.billingInfo?.address?.country}, ${order?.billingInfo?.address?.zipCode}, ${order?.billingInfo?.address?.city}, ${order?.billingInfo?.address?.street}`
      }
    ]
  };

  useEffect(() => {
    if (!(typeof order?.paymentTrxId === 'undefined')) {
      fetchPayment({ id: order?.paymentTrxId });
    }
    if (!(typeof order?.billingTransactionIds === 'undefined')) {
      setInvoice([]);
      fetchInvoice({ IDS: order?.billingTransactionIds });
      /*order?.billingTransactionIds.forEach((el) => {
        fetchInvoice({ id: el });
      })*/
    }
    if (!(typeof order?.deliveryRefs?.deliveryId === 'undefined')) {
      fetchDelivery({
        id: order?.deliveryRefs?.deliveryId
      });
    }
  }, [fetchDelivery, fetchInvoice, fetchPayment, order]);

  const routeChange = () => {
    navigate(-1);
  };

  const linkRef = useRef(null);

  return (
    <Container className='root' maxWidth={'xl'}>
      <a ref={linkRef} />
      <Breadcrumbs aria-label='breadcrumb' className={styles.breadcrumb}>
        <Link color='inherit' className={styles.link} onClick={routeChange}>
          {t('common.back')}
        </Link>
      </Breadcrumbs>
      <Container maxWidth={'xl'} style={{ margin: '0 0 2rem 0' }}>
        <OrderHistoryWidget order={order} handler={getDateString} />
        {loading ? (
          <LoadIndicator color={'var(--primary-light)'} height={800} />
        ) : (
          <>
            <Grid container spacing={3} style={{ margin: '0 0 2rem 0' }}>
              <Slide direction='up' in={true} timeout={1000} unmountOnExit>
                <Grid key={`order_details_card`} item xs={12} md={6} lg={6}>
                  <Paper className={styles.cardHolder} style={{ height: '100%' }}>
                    <DetailsCard
                      title={orderDetailsData.cardTitle}
                      rows={orderDetailsData.rows}
                      icon={orderDetailsData.icon}
                      tooltipText={orderDetailsData.tooltipText}
                      buttonText={orderDetailsData.buttonText}
                      buttonDisabled={false}
                      handler={orderDetailsData?.handler}
                    />
                    {(delivery?.status === 'SHIPPED' || order?.status === 'DONE') && <CheckIcon />}
                  </Paper>
                </Grid>
              </Slide>
              <Slide direction='up' in={true} timeout={1000} unmountOnExit>
                <Grid key={`payment_details_card`} item xs={12} md={6} lg={6}>
                  <Paper className={styles.cardHolder} style={{ height: '100%' }}>
                    <DetailsCard
                      title={paymentDetailsData.cardTitle}
                      rows={paymentDetailsData.rows}
                      icon={paymentDetailsData.icon}
                      tooltipText={paymentDetailsData.tooltipText}
                      buttonText={paymentDetailsData.buttonText}
                      buttonDisabled={paymentDetailsData.buttonDisabled}
                      handler={paymentDetailsData?.handler}
                    />
                    {(paymentStatus === 'PAID' || order?.status === 'DONE') && <CheckIcon />}
                  </Paper>
                </Grid>
              </Slide>
              <Slide direction='up' in={true} timeout={1000} unmountOnExit>
                <Grid key={`shipping_details_card`} item xs={12} md={6} lg={6}>
                  <Paper className={styles.cardHolder} style={{ height: '100%' }}>
                    <DetailsCard
                      title={shippingDetailsData.cardTitle}
                      rows={shippingDetailsData.rows}
                      icon={shippingDetailsData.icon}
                      tooltipText={shippingDetailsData.tooltipText}
                      buttonText={shippingDetailsData.buttonText}
                      buttonDisabled={
                        !emailDeliveryFound ||
                        (user?.ownedShops[0]?.id !== shopId &&
                          !user?.maintainedShops
                            ?.find((shop) => shop.shop.id === shopId)
                            ?.scopes?.includes('MANAGE_ORDERS'))
                      }
                      handler={shippingDetailsData?.handler}
                    />
                    {(delivery?.status === 'SHIPPED' || order?.status === 'DONE') && <CheckIcon />}
                  </Paper>
                </Grid>
              </Slide>
              <Slide direction='up' in={true} timeout={1000} unmountOnExit>
                <Grid key={`billing_details_card`} item xs={12} md={6} lg={6}>
                  <Paper className={styles.cardHolder} style={{ height: '100%' }}>
                    <DetailsCard
                      title={billingDetailsData.cardTitle}
                      rows={billingDetailsData.rows}
                      icon={billingDetailsData.icon}
                      tooltipText={billingDetailsData.tooltipText}
                      buttonText={billingDetailsData.buttonText}
                      buttonDisabled={billingDetailsData.buttonDisabled}
                      handler={billingDetailsData?.handler}
                      downloadProgress={downloadProgress}
                    />
                    {/* {(invoice?.status === "PRINTED" ||
                      order?.status === "DONE") && <CheckIcon />} */}
                    <div className={styles.invoicesCard}>
                      <ul className={styles.listItemTable}>
                        {invoiceLoading ? (
                          <LoadIndicator color={'var(--primary-light)'} height={200} />
                        ) : invoice?.length > 0 ? (
                          invoice?.map((inv) => (
                            <li className={styles.listItem} width='100%' key={inv.id}>
                              <div className={styles.hideXSCell} width='25%'>
                                <Typography className={styles.tableCell}>
                                  <b>{t('orderDetails.invoices', { id: inv?.id })}</b>
                                </Typography>
                              </div>
                              <div className={styles.showXSCell} width='35px'>
                                <Typography className={styles.tableCell}>
                                  <b>{inv?.id}</b>
                                </Typography>
                              </div>
                              <div>
                                {invoiceVendors && (
                                  <Typography className={styles.tableCell}>
                                    {invoiceVendors?.find((v) => v.id === inv.vendorId)
                                      ? invoiceVendors?.find((v) => v.id === inv.vendorId)?.vendorType === 'SZAMLAZZ_HU'
                                        ? 'Számlázz.hu'
                                        : 'Billingo'
                                      : '-'}
                                  </Typography>
                                )}
                              </div>
                              <div className={styles.hideCell} width='20%'>
                                <Typography className={styles.tableCell}>
                                  {inv?.status === 'PRINTED'
                                    ? t('orderDetails.printed')
                                    : inv?.status === 'REJECTED'
                                    ? t('orderDetails.rejected')
                                    : inv?.status}
                                </Typography>
                              </div>
                              <div width='30px'>
                                {inv?.status === 'REJECTED' ? (
                                  <div className={styles.redDot}></div>
                                ) : (
                                  <CheckIcon position={'unset'} />
                                )}
                              </div>
                              <div width='50px'>
                                {!invoiceVendors?.find((v) => v.id === inv.vendorId) ? (
                                  <Tooltip
                                    title={t('orderDetails.noDownload')}>
                                    <IconButton onClick={() => handleGetPdf(inv?.id)} disabled={true}>
                                      <DownloadIcon></DownloadIcon>
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  <IconButton
                                    onClick={() => handleGetPdf(inv?.id)}
                                    disabled={inv?.status === 'REJECTED'}>
                                    <DownloadIcon></DownloadIcon>
                                  </IconButton>
                                )}
                              </div>
                            </li>
                          ))
                        ) : (
                          ''
                        )}
                      </ul>
                    </div>
                  </Paper>
                </Grid>
              </Slide>

              <Slide direction='up' in={true} timeout={1000} unmountOnExit>
                <Grid key={`status_selector`} item xs={12}>
                  <Paper className={styles.cardHolder}>
                    <StatusModifier putOrder={putOrder} order={order} />
                  </Paper>
                </Grid>
              </Slide>

              {order?.items && (
                <Slide direction='up' in={true} timeout={1000} unmountOnExit>
                  <Grid key={`order_list`} item xs={12}>
                    <Paper className={styles.orderListWrapper}>
                      <OrderList shopId={shopId} cartItems={order?.items} />
                    </Paper>
                  </Grid>
                </Slide>
              )}
            </Grid>
          </>
        )}
      </Container>
      <HistoryViewer
        data={order}
        historyVisible={orderHistoryVisible}
        toggleHistoryVisible={toggleOrderHistoryVisible}
      />
      <HistoryViewer
        data={payment}
        historyVisible={paymentHistoryVisible}
        toggleHistoryVisible={togglePaymentHistoryVisible}
      />

      <ConfirmDialog
        title={t('orderDetails.rePrint')}
        functionButtonText={t('common.yes')}
        closeButtonText={t('common.cancel')}
        multipleButtons={true}
        functionButtonColor={'var(--primary-success)'}
        onClose={toogleReprintDialogOpen}
        open={reprintDialogOpen}
        onOk={() => {
          handleReprint(postDeliveryFound?.deliveryId);
          toogleReprintDialogOpen();
        }}
      />
      <Dialog
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}>
        <DialogTitle>{t('orderDetails.giveNewAddress')}</DialogTitle>
        <TextField
          className={styles.newEmail}
          autoFocus
          type='email'
          label={t('orderDetails.newAddress')}
          variant='outlined'
          onChange={(e) => {
            setNewEmail(e.target.value);
          }}
        />
        <Button
          color='primary'
          disabled={newEmail === ''}
          className={styles.resendConfirm}
          onClick={() => {
            resendDigital();
            setIsOpen(false);
          }}>
          {t('orderDetails.send')}
        </Button>
      </Dialog>
    </Container>
  );
};

export default OrderDetails;
